import { useBoardValues } from "@swivu/client-api";

type BoardValuesProps = Parameters<typeof useBoardValues>[0] & {
  children: (values: string[]) => React.ReactNode;
};

const BoardValues = (props: BoardValuesProps) => {
  const { route, id, valueIds, children } = props;
  const { values } = useBoardValues({ route, id, valueIds });
  if (!values || values.length === 0) {
    return null;
  }
  return <>{children(values)}</>;
};

export default BoardValues;
